<script>
    export let model_root;

    let prename = "";
    let name = "";
    let mail = "";
    let uid = 0;
    let registered = "";

    let errorMsg = "";
    let successMsg = "";
    let isLoading = true;

    // Eigene Daten laden
    fetch(model_root + 'admin/user_management/get_current_user.php')
        .then(res => res.json())
        .then(data => {
            prename = data.uprename;
            name = data.uname;
            mail = data.umail;
            registered = data.uregistered;
            uid = data.uid;
            isLoading = false;
        });

    function updateProfile() {
        const data = new FormData();
        data.append("action", "update");
        data.append("uid", uid);
        data.append("prename", prename);
        data.append("name", name);
        data.append("mail", mail);

        fetch(model_root + 'admin/user_management/manage_user.php', {
            method: "POST",
            body: data
        })
            .then(response => response.json())
            .then(data => {
                if(data.status === "success") {
                    successMsg = "Profil erfolgreich aktualisiert.";
                    setTimeout(() => successMsg = "", 3000);
                } else {
                    errorMsg = data.message;
                }
            });
    }
</script>

{#if isLoading}
    <p class="text-center mt-5"><i class="fas fa-circle-notch fa-spin"></i> Profil wird geladen...</p>
{:else}
    <div class="card p-4 border-0 shadow-sm mt-3">
        <h5 class="mb-4"><i class="fas fa-user-circle"></i> Mein Profil</h5>

        <form on:submit|preventDefault={updateProfile}>
            <div class="row mb-3">
                <div class="col-md-6">
                    <label class="form-label" for="my_prename">Vorname</label>
                    <input type="text" class="form-control" id="my_prename" bind:value={prename}>
                </div>
                <div class="col-md-6">
                    <label class="form-label" for="my_name">Nachname</label>
                    <input type="text" class="form-control" id="my_name" bind:value={name}>
                </div>
            </div>

            <div class="mb-3">
                <label class="form-label" for="my_mail">E-Mail Adresse</label>
                <input type="email" class="form-control" id="my_mail" bind:value={mail}>
            </div>

            <div class="mb-4 text-muted small">
                Registriert seit: {registered}
            </div>

            {#if errorMsg}
                <div class="alert alert-danger">{errorMsg}</div>
            {/if}
            {#if successMsg}
                <div class="alert alert-success">{successMsg}</div>
            {/if}

            <button type="submit" class="btn btn-primary btn-maleck">
                Daten aktualisieren
            </button>
        </form>
    </div>
{/if}

<style>
    .btn-maleck {
        background: #2f3e51;
        border-color: #2f3e51;
    }
</style>
